import React from "react";

import { AreaContentProps } from "./types";
import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  label: {
    lineHeight: "22px",
    letterSpacing: "0.1px",
    color: theme.palette.text.secondary,
  },
}));

const AreaContent: React.FC<AreaContentProps> = ({ label, text }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography
          className={classes.label}
          data-test="area-card-content-label"
          variant="body2"
        >
          {label}
        </Typography>
        {text && (
          <Typography data-test="area-card-content-text" variant="subtitle2">
            {text}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default AreaContent;
